/**
 * 헤더 컴포넌트
 * - 사이드바 토글 버튼
 * - 사용자 정보 및 역할 배지
 * - 로그아웃 기능
 */

import React from 'react';
import { Layout, Button, Space, Avatar, Dropdown, Tag, Typography } from 'antd';
import type { MenuProps } from 'antd';
import {
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { HeaderProps } from './types';
import { useAuth } from '../../hooks/useAuth';
import { getRoleLabel, getRoleColor } from './menuConfig';

const { Header } = Layout;
const { Text } = Typography;

/**
 * 헤더 컴포넌트
 */
export const AppHeader: React.FC<HeaderProps> = ({
  onToggleSidebar,
  title,
}) => {
  const { user, logout } = useAuth();

  /**
   * 사용자 드롭다운 메뉴 아이템
   */
  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: (
        <div>
          <div><strong>{user?.name}</strong></div>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {user?.email}
          </Text>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '설정',
      onClick: () => {
        // 향후 설정 페이지로 이동
        console.log('설정 페이지로 이동');
      },
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '로그아웃',
      danger: true,
      onClick: logout,
    },
  ];

  return (
    <Header
      style={{
        padding: '0 24px',
        background: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 1px 4px rgba(0,21,41,.08)',
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }}
    >
      {/* 좌측: 토글 버튼 + 타이틀 */}
      <Space size="large">
        <Button
          type="text"
          icon={<MenuFoldOutlined />}
          onClick={onToggleSidebar}
          style={{
            fontSize: '16px',
            width: 40,
            height: 40,
          }}
        />
        {title && (
          <Text strong style={{ fontSize: '18px' }}>
            {title}
          </Text>
        )}
      </Space>

      {/* 우측: 사용자 정보 드롭다운 */}
      {user && (
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar
              icon={<UserOutlined />}
              style={{ backgroundColor: '#1890ff' }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Text strong>{user.name}</Text>
              <Tag color={getRoleColor(user.role)} style={{ margin: 0, fontSize: '11px' }}>
                {getRoleLabel(user.role)}
              </Tag>
            </div>
          </Space>
        </Dropdown>
      )}
    </Header>
  );
};
